import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from './actionTypes';
import { loginSuccess, logoutUserSuccess, apiError } from './actions';

//AUTH related methods
import AuthService from '../../../services/AuthService';
import session from 'redux-persist/lib/storage/session';


function* loginUser({ payload: { user, history } }) {
    try {
        const response = yield call(AuthService.login, user.user_email, user.password);
        console.log('login response from saga.js', response)
        //const response = yield call(AuthService.login, user.user_email, user.user_name, user.password);
        if(sessionStorage.getItem("uid")){
            yield put(loginSuccess(response.data));
            // if (response[0].override_sector == '1') {
            //     yield history.push('/select_sector');
            //     return;
            // }
            sessionStorage.setItem("override_sector", response.data.override_sector);
			history.push('/dashboard');
		}else{
			yield put(apiError({error:true}));
		}
		
    } catch (error) {
        yield put(apiError(error));
    }
}

function* logoutUser({ payload: { history } }) {
    try {
        const response = yield call(AuthService.logout);
        yield put(logoutUserSuccess(response));
        history.push('/login');
    } catch (error) {
        yield put(apiError(error));
    }
}


export function* watchUserLogin() {
    yield takeEvery(LOGIN_USER, loginUser)
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUser)
}

function* authSaga() {
    yield all([
        fork(watchUserLogin),
        fork(watchUserLogout),
    ]);
}

export default authSaga;